import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _UBLInvoice } from "../../../../core/services/dataBean/EntityCatalog";

interface Props {
    label?: string;
    disable?: boolean;
    idSelect: number | null;
    onChange: Function;
    Numberselect?: number;
}
export const SelectUBLDocumentTypeConstants = ({ idSelect, label, disable, onChange, Numberselect }: Props) => {

    const { lista, setLista, instance } = useDataBean(_UBLInvoice);
    // const [id, setId] = useState<number>(NaN);
    const [id, setID] = useState<number>(idSelect);
    // useEffect(() => {

    //     const param = Numberselect ?? null;

    //     instance.getUBLDocumentTypeConstants(param).then((resp: any) => {
    //         setLista(resp);
    //     });
    // }, [Numberselect]); 

    // useEffect(() => {
    //     if (idSelect != id) {
    //         setId(idSelect);
    //     }
    // }, [idSelect])

    // const setValue = (e: any) => {
    //     setId(e);
    //     onChange(e);
    // }
    useEffect(() => {
        getLista();
    }, [Numberselect]);

    useEffect(() => {
        if (idSelect !== id) {
            setID(idSelect);
            ////console.log(idSelect)
        }
    }, [idSelect]);

    const setValue = (e: any) => {
        const selectedID = parseInt(e);
        onChange(selectedID);
    };


    const getLista = () => {
        const param = Numberselect ?? null;
        instance.getUBLDocumentTypeConstants(param).then(
            (resp: any) => {
                if (resp) {
                    console.log(Numberselect)
                    setLista(resp);
                }
            }
        );
    };
    return (
        <>
            <label>{label ?? 'Tipo de Factura'}</label>
            {/* <select className="form-select" disabled={disable ?? false} value={id} onChange={(e) => { setValue(parseInt(e.target.value)) }}>
                <option value={NaN}>...</option>
                {lista.map((item: any) => {
                    return (
                        <option value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Property}</option>
                    )
                })}
            </select> */}
            <select className="form-select" disabled={disable ?? false} value={id} onChange={(e) => setValue(e.target.value)}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.Value}>
                            {item.DataBeanProperties.Property}
                        </option>
                    ))
                }
            </select>
        </>
    )
}